import React from "react";
import { Route, Routes } from "react-router-dom";
import { MentorsView } from "./Mentors/MentorsView";
import MentorDetailView from "./Form/MentorDetail/MentorDetailView";
import { MentorLayout } from "./Layouts/MentorLayout";

const MentorsRoutes: React.FC = () => {
    return (
        <Routes>
            <Route element={<MentorLayout />}>
                <Route path={"*"} element={<MentorsView />} />
                <Route path={"mentor"} element={<MentorDetailView />} />
                <Route path={"mentor/:id"} element={<MentorDetailView />} />
            </Route>
        </Routes>
    );
};

export default MentorsRoutes;
